'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _context = require('@prisma-cms/context');

var _context2 = _interopRequireDefault(_context);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var PrismaCmsConnector = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(PrismaCmsConnector, _Component);

  function PrismaCmsConnector() {
    (0, _classCallCheck3.default)(this, PrismaCmsConnector);
    return (0, _possibleConstructorReturn3.default)(this, (PrismaCmsConnector.__proto__ || (0, _getPrototypeOf2.default)(PrismaCmsConnector)).apply(this, arguments));
  }

  (0, _createClass3.default)(PrismaCmsConnector, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var Query = this.prepareQuery();
      this.Query = Query;
    }
  }, {
    key: 'prepareQuery',
    value: function prepareQuery() {
      console.error("You should override prepareQuery method.");
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var other = (0, _objectWithoutProperties3.default)(this.props, []);
      var Query = this.Query;

      if (!Query) {
        console.error("Query is null");
        return null;
      }

      return _react2.default.createElement(Query, other);
    }
  }]);
  return PrismaCmsConnector;
}(_react.Component), _class.contextType = _context2.default, _class.propTypes = {
  getQueryFragment: _propTypes2.default.func
}, _temp);
exports.default = PrismaCmsConnector;